var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"aj-star"},_vm.$listeners),[_c('aj-icon',{staticClass:"aj-star__icon",class:_vm.classObject,attrs:{"shape":"star"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }